import { render, staticRenderFns } from "./popup-list.vue?vue&type=template&id=a4d90b46"
import script from "./popup-list.vue?vue&type=script&lang=js"
export * from "./popup-list.vue?vue&type=script&lang=js"
import style0 from "./popup-list.vue?vue&type=style&index=0&id=a4d90b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./popup-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports